export default function defaultAcceptError(type: string, accepts: string) {
    const prettyAccepts = accepts
        .split(',')
        .map((a) => a.trim())
        .join(', ');
    return 'File type "' + type + '" is not allowed. Accepts: ' + prettyAccepts;
}
